import { T_SUBSCRIPTION_CARD_PAGE_CONSTANTS } from './TYPES'

const HU_SUBSCRIPTION_CARD_PAGE_CONSTANTS: T_SUBSCRIPTION_CARD_PAGE_CONSTANTS =
  {
    CHAMPION: {
      TITLE: 'Bajnok',
      DESCRIPTION: 'A legjobb választás {{minUser}}+ felhasználó számára',
      TENURE_LABEL_TEXT: 'Válassza ki az időtartamot',
      TENURES_MAP: {
        6: '6 hónap',
        12: '1 év',
        LIFETIME: 'Élettartam'
      },
      YOU_WILL_PAY_TEXT: 'AZ ÖN ÁLTAL FIZETENDŐ ÖSSZEG',
      YOU_WILL_PAY_USER_TEXT: 'felhasználó',
      BUY_CTA_TEXT: 'Előfizetési opció vásárlása'
    },
    PREMIUM: {
      TITLE: 'Prémium',
      DESCRIPTION: 'A legjobb választás {{minUser}}+ felhasználó számára',
      TENURE_LABEL_TEXT: 'Válassza ki az időtartamot',
      TENURES_MAP: {
        6: '6 hónap',
        12: '1 év',
        LIFETIME: 'Élethosszig'
      },
      YOU_WILL_PAY_TEXT: 'AZ ÖN ÁLTAL FIZETENDŐ ÖSSZEG',
      YOU_WILL_PAY_USER_TEXT: 'felhasználó',
      BUY_CTA_TEXT: 'Előfizetési opció vásárlása'
    },
    ADVENTURE: {
      TITLE: 'Kaland',
      DESCRIPTION: 'A legjobb választás egyéni felhasználók számára',
      TENURE_LABEL_TEXT: 'Válassza ki az időtartamot',
      TENURES_MAP: {
        6: '6 hónap',
        12: '1 év',
        LIFETIME: 'Élettartam'
      },
      YOU_WILL_PAY_TEXT: 'Az ÖN ÁLTAL FIZETENDŐ ÖSSZEG',
      YOU_WILL_PAY_USER_TEXT: 'felhasználó',
      BUY_CTA_TEXT: 'Előfizetési opció vásárlása'
    }
  }

export default HU_SUBSCRIPTION_CARD_PAGE_CONSTANTS
